// MovieDetails.js
import React from "react"
import "./movieDetails.css"

const MovieDetails = ({ movie }) => {
  // Since initially movie is null, we handle loading state outside or inside this component.
  console.log(movie)
  if (!movie) {
    return <p>Loading...</p>
  }

  return (
    <div className="card mt-4">
      <img
        src={"https://image.tmdb.org/t/p/w500/" + movie.poster_path}
        alt={movie.Title}
        className="card-img-top poster-image"
      />
      <div className="card-body">
        <h5 className="card-title">{movie.title}</h5>
        <p className="card-text">{movie.overview}</p>
      </div>
    </div>
  )
}

export default MovieDetails
